import getConfig from 'next/config'
import Image, { ImageProps } from 'next/image'
import React from 'react'

type ImageOptions = { [x: string]: string | number }
type MyImageProps = ImageProps & { imageOptions: ImageOptions }

export const PondImage: React.FC<MyImageProps> = ({ imageOptions, ...props }) => {
  return <Image loader={myLoader(true, imageOptions)} {...props} />
}

const myLoader =
  (hasBasePath: boolean, imageOptions: ImageOptions) =>
  ({ src, width }: { src: ImageProps['src']; width }): string => {
    const {
      publicRuntimeConfig: { imageBasePath = '', imgixDefaultOptions },
    } = getConfig()

    const basePath = hasBasePath ? '' : imageBasePath
    const imgixAdditionalOptions = Object.keys(imageOptions).reduce(
      (acc, key) => `${acc}&${key}=${imageOptions[key]}`,
      ''
    )
    const path = encodeURI(`${basePath}${src}?${imgixDefaultOptions}${imgixAdditionalOptions}`)
    return !path.includes('&w=') && width ? `${path}&w=${width}` : path
  }
